module.exports = __webpack_public_path__ + "img/bg@4x.677339f2.png";